import Loading from '../../../../ions/Loading';
import { ApiResource } from '../hooks/useApiResource';
import { EmptyState, LoadError } from './ui';

interface ResourceStateProps<T> {
  resource: ApiResource<T[]>;
  emptyText: string;
}

const ResourceState = <T,>({ resource, emptyText }: ResourceStateProps<T>) => (
  <>
    {resource.loading && <Loading />}
    {resource.error && <LoadError message={resource.error} onRetry={resource.reload} />}
    {!resource.loading && !resource.error && resource.data?.length === 0 && <EmptyState text={emptyText} />}
  </>
);

export default ResourceState;
